import React, { Component } from 'react';
import PropTypes from 'prop-types';
import MaterialTextEditor from '../Common/TextEditor/MaterialTextEditor';
import { cloneDeep, throttle } from 'lodash';
import ShareService from '../../apiclients/ShareService';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import { withStyles } from '@material-ui/core/styles';
import AttachmentManager from '../Common/MailShareDialog/AttachmentManager';
import ZohoService from './ZohoService';
import NewSearch from '../Library/NewSearch';
import isEmail from 'validator/lib/isEmail';
import zohoLogo from './zoho.png';

const styles = theme => ({
    root: {
        display: 'flex',
        justifyContent: 'justify',
        flexWrap: 'wrap'
    },
});

class MailShareDialog extends Component {
    constructor(props) {
        super(props);
        this.state = {
            open: false,
            recipient: '',
            reference: '',
            subject: '',
            body: '',
            attachments: props.attachments,

            zohoLoading: false,
            results: {
                account: { name: '', results: [] },
                contacts: { name: '', results: [] },
            }
        };
        this.notifyId = undefined;

        this.autocomplete = throttle(this.autocomplete, 1000);
    }

    // static getDerivedStateFromProps(nextProps, prevState) {
    //     if (!this.areArraysEqual(nextProps.attachments, prevState.attachments)) {
    //         return { attachments: cloneDeep(prevState.attachments) };
    //     } else {
    //         return null;
    //     }
    // }

    componentDidUpdate = (prevProps, prevState) => {
        if (!this.areArraysEqual(this.props.attachments, prevProps.attachments)) {
            this.setState({ attachments: cloneDeep(this.props.attachments) });
        }
    };

    areArraysEqual = (arrayA, arrayB) => {
        if ((arrayA === undefined && arrayB !== undefined) || (arrayA !== undefined && arrayB === undefined))
            return false;
        if (arrayA.length !== arrayB.length)
            return false;
        for (let a = 0; a < arrayA.length; a++) {
            let found = false;
            for (let b = 0; b < arrayB.length && found === false; b++) {
                if (arrayA[a].identifier === arrayB[b].identifier) {
                    found = true;
                }
            }
            if (found === false) {
                return false;
            }
        }
        return true;
    }

    // https://stackoverflow.com/a/46181
    validateRecipient = () => {
        var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(this.state.recipient).toLowerCase());
    };

    handleRecipientChange = (newValue, evt) => {

        if (evt.action !== 'input-change') return;

        this.setState({ recipient: newValue });
        this.autocomplete(newValue);
    };

    validateEmail = email => {
        return isEmail(email, { allow_display_name: true });
    };

    autocomplete = async (value) => {

        if (value && value.length >= 4) {
            this.setState({ zohoLoading: true });
            let results = {
                email: {
                    name: 'Email',
                    results: [],
                },
                contacts: {
                    name: 'Contacts',
                    results: [],
                }
            };

            let email = value.trim();
            if (this.validateEmail(email)) {
                results.email.results.push({
                    'label': email, 'value': email, type: 'email'
                });
            }
            try {
                console.log('auto value', value);
                let response = await ZohoService.searchInZoho(value);
                console.log('response', response);
                response.forEach((element) => {
                    if (element.account !== undefined) {
                        let accountId = element.account.id;
                        if (results[accountId] === undefined) {
                            results[accountId] = {
                                name: element.account.name,
                                results: [],
                            };
                        }
                        let account = results[accountId];
                        account.results.push({
                            'label': `${element.fullName} <${element.email}>`, 'value': element.email, type: accountId
                        });
                    } else {
                        results.contacts.results.push({
                            'label': `${element.fullName} <${element.email}>`, 'value': element.email, type: 'contacts'
                        });
                    }
                });
                // console.log('autocomplete', response, results);
            } catch (err) {
                console.log(err.message);
            }
            this.setState({ zohoLoading: false, results });
        }
    }

    handleReferenceChange = evt => {
        this.setState({ reference: evt.target.value });
    };

    handleSubjectChange = evt => {
        this.setState({ subject: evt.target.value });
    };

    handleContentBodyChange = (slot, newBody) => {
        this.setState({ body: newBody });
    };

    handleClickOpen = () => {
        this.setState({ open: true });
    };

    handleClose = () => {
        this.setState({ open: false });
    };

    handleShareFile = () => {
        let recipient = this.state.activeFilters.value;
        console.log(recipient);
        if (recipient === '') {
            this.notifyId = this.props.notify('error', 'e-Mail is empty', this.notifyId);
        } else if (!this.validateEmail(recipient)) {
            this.notifyId = this.props.notify('error', 'e-Mail is not valid', this.notifyId);
        } else if (this.state.subject === '') {
            this.notifyId = this.props.notify('error', 'Subject is empty', this.notifyId);
        } else if (this.state.body === '') {
            this.notifyId = this.props.notify('error', 'Message is empty', this.notifyId);
        } else {
            this.notifyId = this.props.notify('info', 'Sending...', this.notifyId);

            let attachments = this.state.attachments.map((att) => {
                return {
                    identifier: att.identifier,
                    name: att.name,
                    url: att.url,
                };
            });

            ShareService.shareFile(
                recipient,
                this.state.reference ? this.state.reference : '',
                this.state.subject,
                this.state.body,
                attachments
            ).then(res => {
                this.notifyId = this.props.notify('info', 'Message sent', this.notifyId);
                this.props.onSuccess();
            }).catch(err => {
                this.notifyId = this.props.notify('error', 'Could not sent the message', this.notifyId);
                this.props.onError(err);
            });
        }
    };

    handleDelete = index => () => {
        let newAttachments = cloneDeep(this.state.attachments);
        newAttachments.splice(index, 1);
        this.setState({ attachments: newAttachments });
    };

    onAttachmentsChange = (attachments) => {
        this.setState({ attachments });
    }

    handleSelectedResult = (values) => {
        let { results } = this.state;
        let reference;
        if (values.type !== 'contacts' && values.type !== 'email') {
            reference = `${values.type} - ${results[values.type].name}`;
        } else {
            reference = '';
        }
        this.setState({ activeFilters: values, recipient: '', reference });
    }

    render() {
        let { results } = this.state;
        let keys = ['firstResults', 'secondResults', 'thirdResults', 'fourthResults', 'fifthResults'];
        let realResults = {};
        Object.keys(results).forEach((resultsKey, i) => {
            if (i < keys.length) {
                realResults[keys[i]] = results[resultsKey];
            }
        });

        return (
            <div>
                <DialogTitle style={{ position: 'relative' }}>

                    {'Share'}
                    <div style={{ position: 'absolute', top: '5px', right: '5px', textAlign: 'right', display: 'inline-block', fontSize:'12px' }}>
                        {'Integrated with:'}
                        <img src={zohoLogo} alt='zoho logo' width='100px' style={{
                            verticalAlign: 'middle',
                            margin: '5px'
                        }} />
                    </div>

                </DialogTitle>
                <DialogContent>
                    <NewSearch
                        usePortal={true}
                        // isMulti={false}
                        placeholder={'Email Address'}
                        isLoading={this.state.zohoLoading}
                        value={this.state.recipient}
                        onResultSelect={this.handleSelectedResult}
                        onSearchChange={this.handleRecipientChange}
                        activeFilters={this.state.activeFilters}
                        firstResults={realResults.firstResults}
                        secondResults={realResults.secondResults}
                        thirdResults={realResults.thirdResults}
                        fourthResults={realResults.fourthResults}
                        fifthResults={realResults.fifthResults}
                    />
                    {/* <TextField
                        autoFocus
                        margin="dense"
                        label={'Email Address'}
                        type="email"
                        fullWidth
                        value={this.state.recipient}
                        onChange={this.handleRecipientChange}
                    /> */}
                    <TextField
                        margin="dense"
                        label={'Reference'}
                        fullWidth
                        value={this.state.reference}
                        onChange={this.handleReferenceChange}
                    />
                    <TextField margin="dense" label="Subject" fullWidth value={this.state.subject} onChange={this.handleSubjectChange} />
                    <MaterialTextEditor
                        slot="body"
                        placeholder={'Message'}
                        simpleMode={false}
                        content={this.state.body}
                        onChange={this.handleContentBodyChange}
                    />
                    <br />
                    <div className={this.props.classes.root}>
                        <AttachmentManager
                            notify={this.props.notify}
                            attachments={this.state.attachments}
                            onAttachmentsChange={this.onAttachmentsChange}
                        />
                    </div>
                    <br />
                    <DialogContentText>{'** Shared content will be available during 1 year'}</DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={this.props.onClose} color="primary">
                        {'Cancel'}
                    </Button>
                    <Button onClick={this.handleShareFile} color="primary">
                        {'Share'}
                    </Button>
                </DialogActions>
            </div>
        );
    }
}

MailShareDialog.propTypes = {

    attachments: PropTypes.array.isRequired, //[{name: '', url: '', identifier: '', icon?: '', isImage?:true|false }]

    notify: PropTypes.func.isRequired,
    onError: PropTypes.func.isRequired,
    onSuccess: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,

    classes: PropTypes.object.isRequired
};

export default withStyles(styles)(MailShareDialog);
